const NEWS_API_BASE = 'https://fantasysoccer.vodacomfantasy.com/api/news';

// Sport configurations
export const SPORTS = {
  CRICKET: { id: '3', code: 'CRIC', name: 'Cricket' },
  SOCCER: { id: '1', code: 'SOCC', name: 'Soccer' },
  RUGBY: { id: '5', code: 'RUGU', name: 'Rugby' },
  MOTORSPORT: { id: '4', code: 'FO1', name: 'Formula 1' },
};

/**
 * Fetch news content by sport type
 * Returns imagesArray, videosArray, and textArray
 */
export const fetchNewsByType = async (topicCode) => {
  const response = await fetch(`${NEWS_API_BASE}/get-news-by-type`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ topicCode }),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch news: ${response.statusText}`);
  }

  const data = await response.json();

  // Filter out images with null URLs
  const images = (data.imagesArray || []).filter(
    img => img.LargeImageUrl && img.SmallImageUrl
  );

  // Videos already have URLs, but filter just in case
  const videos = (data.videosArray || []).filter(
    vid => vid.VideoUrl && vid.ImageUrl
  );

  // Filter out text articles with null BodyText
  const textArticles = (data.textArray || []).filter(
    txt => txt.BodyText
  );

  return { images, videos, textArticles };
};

/**
 * Upload a new article to the database
 */
export const uploadArticle = async ({
  sportId,
  title,
  description,
  type,
  guid,
  articleBody,
}) => {
  const response = await fetch(`${NEWS_API_BASE}/upload-article`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      sportId,
      title,
      description,
      type,
      guid,
      articleBody,
      mediaProvider: 'Penrose_LLM',
    }),
  });

  if (!response.ok) {
    throw new Error(`Failed to upload article: ${response.statusText}`);
  }

  // Handle empty response body
  const text = await response.text();
  return text ? JSON.parse(text) : { success: true };
};

/**
 * Mark an image as used
 */
export const markImageAsUsed = async (imageMetadataId) => {
  const response = await fetch(`${NEWS_API_BASE}/update-article-used`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ImageMetadataID: imageMetadataId }),
  });

  if (!response.ok) {
    throw new Error(`Failed to mark image as used: ${response.statusText}`);
  }

  // Handle empty response body
  const text = await response.text();
  return text ? JSON.parse(text) : { success: true };
};

/**
 * Mark a video as used
 */
export const markVideoAsUsed = async (videoMetadataId) => {
  const response = await fetch(`${NEWS_API_BASE}/update-article-used`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ VideoMetadataID: videoMetadataId }),
  });

  if (!response.ok) {
    throw new Error(`Failed to mark video as used: ${response.statusText}`);
  }

  // Handle empty response body
  const text = await response.text();
  return text ? JSON.parse(text) : { success: true };
};

/**
 * Mark a text article as used
 */
export const markTextAsUsed = async (textMetadataId) => {
  const response = await fetch(`${NEWS_API_BASE}/update-article-used`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ TextMetadataID: textMetadataId }),
  });

  if (!response.ok) {
    throw new Error(`Failed to mark text as used: ${response.statusText}`);
  }

  // Handle empty response body
  const text = await response.text();
  return text ? JSON.parse(text) : { success: true };
};
